<template>
  <div class="carrier-network">
    <Header />
    <div class="container mx-auto px-4 pt-24 pb-16">
      <h1 class="text-4xl font-bold mb-8 text-center">运营商网络 - 构建下一代智能通信基础设施</h1>
      
      <div class="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">引领5G时代的通信网络架构</h2>
          <p class="text-gray-700 mb-4">
            在全球5G基础设施建设的浪潮中，chmura云通讯凭借深厚的技术积累和创新能力，构建了业界领先的运营商网络解决方案。我们的网络架构融合了云计算、大数据、AI等前沿技术，为全球运营商提供端到端的5G网络部署和优化服务。
          </p>
          <p class="text-gray-700 mb-4">
            截至2025年，chmura云通讯已在全球20多个国家和地区部署了5G网络，覆盖超过150个城市，服务用户突破3亿。我们的5G网络解决方案在频谱效率、网络容量和覆盖范围等关键指标上均处于行业领先水平。
          </p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">核心技术优势</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">超密集网络部署</h3>
              <p class="text-gray-700">通过智能天线、波束赋形和大规模MIMO技术，实现网络容量提升10倍，覆盖范围扩大30%。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">边缘计算与网络切片</h3>
              <p class="text-gray-700">支持毫秒级时延应用场景，为工业互联网、自动驾驶等垂直行业提供专属网络切片。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">智能运维系统</h3>
              <p class="text-gray-700">基于AI的网络优化平台，实现故障预测准确率95%，运维效率提升70%。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">绿色节能技术</h3>
              <p class="text-gray-700">通过能效优化算法和绿色能源解决方案，实现网络能耗降低40%。</p>
            </div>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">市场成就与客户案例</h2>
          <p class="text-gray-700 mb-4">
            chmura云通讯运营商网络解决方案已成功服务于全球顶级运营商，包括中国移动、中国电信、沃达丰、德国电信等。在与中国移动的合作中，我们共同打造了全球最大的5G独立组网（SA）网络，网络覆盖率达到99.9%，用户满意度评分4.8/5。
          </p>
          <p class="text-gray-700">
            在欧洲市场，我们帮助德国电信实现了5G网络的快速部署，覆盖德国主要城市，网络下载速度达到1.2Gbps，为用户提供了高品质的移动互联网体验。
          </p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">未来发展方向</h2>
          <p class="text-gray-700 mb-4">
            chmura云通讯将继续加大在运营商网络领域的研发投入，重点布局6G技术、量子通信、卫星通信等前沿领域。我们致力于构建天地一体化的通信网络，为用户提供无处不在的优质通信服务。
          </p>
          <p class="text-gray-700">
            同时，我们将持续优化网络架构，提升网络性能和用户体验，推动通信技术与各个行业的深度融合，为数字经济的发展提供坚实的网络支撑。
          </p>
        </div>

        <div class="text-center">
          <el-button type="primary" size="large" @click="$router.push('/contact')" class="bg-blue-600 hover:bg-blue-700">
            联系我们了解更多
          </el-button>
        </div>
      </div>
    </div>
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import BackToTop from '../components/BackToTop.vue'

export default {
  name: 'CarrierNetwork',
  components: {
    Header,
    Footer,
    BackToTop
  }
}
</script>

<style scoped>
.carrier-network {
  padding-top: 80px;
}
</style>
